import { styled } from '@mui/material/styles';
import Link from 'next/link';

import { Theme, rem } from '../../theme';

export const StyledPriceContainer = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const StyledPrice = styled('div')`
    align-self: center;
    margin-right: ${({ theme }: { theme: Theme }) =>
        theme.tggSpacing(rem(0.5), 1.25)};
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmallBold};
    color: ${({ theme }: { theme: Theme }) => theme.palette.primary.main};
`;

export const StyledDiscountedPrice = styled('span')`
    text-decoration: line-through;
    white-space: break-spaces;
`;

export const StyledDuration = styled('span')`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_lh_21}
    color: ${({ theme }: { theme: Theme }) => theme.palette.common.blue};
    white-space: break-spaces;
`;

export const StyledText = styled('span')`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmallBold}
`;

export const StyledPriceAndDuration = styled('div')`
    display: flex;
`;

export const StyledTCText = styled('p')`
    ${({ theme }: { theme: Theme }) => theme.typography.bodyXXSmallBold}

    display: flex;
    margin: ${({ theme }: { theme: Theme }) => theme.tggSpacing(0, 0)};
    text-decoration: none;
    white-space: break-spaces;
`;

export const StyledTCLink = styled(Link)`
    color: inherit;
`;
